export const getProfileDisplayName = (profile = {}) => {
  const role = String(profile.role || "").trim().toLowerCase();
  const personalName = [
    profile.firstname || profile.first_name,
    profile.lastname || profile.last_name
  ].filter(Boolean).join(" ").trim();

  const namesByRole = {
    club: profile.club_name,
    brand: profile.brand_name || profile.legal_name || profile.company_name,
    media: profile.company_name || profile.media_name
  };

  return (
    profile.display_name ||
    profile.full_name ||
    profile.name ||
    namesByRole[role] ||
    personalName ||
    profile.username ||
    ""
  );
};
